export default function LightBoard() {
  return (
    <section className="w-full bg-white py-20 px-6">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-3xl font-bold text-[#1a1a2e] mb-3">VergeOS Mimarisine Genel Bakışı</h2>
        <p className="text-[#64748b] text-base mb-10 max-w-2xl">
          Uzmanlarımızın VergeOS mimarisini adım adım anlattığı bu detaylı videoyu izleyin ve sistemin nasıl çalıştığını keşfedin.
        </p>
        <div className="w-full rounded-2xl overflow-hidden bg-[#0f1117] relative" style={{ aspectRatio: '16/7' }}>
          <img
            src="https://public.readdy.ai/ai/img_res/942c984f4741d7275e719758917eb6ce.jpg"
            alt="VergeOS Mimari Video"
            className="w-full h-full object-cover object-top"
          />
          {/* Play overlay */}
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/40">
            <a
              href="https://videopress.com/v/IWYi4JAd"
              target="_blank"
              rel="nofollow noreferrer"
              className="group flex flex-col items-center gap-4 cursor-pointer"
            >
              <span className="w-20 h-20 flex items-center justify-center rounded-full bg-[#e8600a] group-hover:bg-[#cc5208] transition-colors">
                <i className="ri-play-fill text-white text-3xl ml-1"></i>
              </span>
              <span className="text-white text-base font-semibold">Videoyu İzle</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
